import { OnboardingProcessStepNameType } from 'api/types/entity';

import {
  CitizenshipStep,
  PepConnectionStep,
  RegistrationAddressStep,
  TaxResidencyStep,
  PersonalDataStep,
  HeadPositionStep,
} from './steps';
import { RoutePage } from './types';

export const pagesMap: Partial<
  Record<OnboardingProcessStepNameType, RoutePage['component']>
> = {
  [OnboardingProcessStepNameType.LegalClientHeadPersonalData]: PersonalDataStep,
  [OnboardingProcessStepNameType.LegalClientHeadPosition]: HeadPositionStep,
  [OnboardingProcessStepNameType.LegalClientHeadCitizenships]: CitizenshipStep,
  [OnboardingProcessStepNameType.LegalClientHeadTaxResidencies]:
    TaxResidencyStep,
  [OnboardingProcessStepNameType.LegalClientHeadAddresses]:
    RegistrationAddressStep,
  [OnboardingProcessStepNameType.LegalClientHeadPep]: PepConnectionStep,
};
